
import { useEffect } from "react";
import { useTheme } from "./use-theme";

/**
 * Hook para detectar cambios en la preferencia del sistema (claro/oscuro)
 * y actualizar el tema si está configurado como "system"
 */
export function useThemeSystemPreference() {
  const { theme, setTheme } = useTheme();

  useEffect(() => {
    // Solo activar si el tema está configurado para seguir al sistema
    if (theme !== "system") return;

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    
    // Handler para cambios en la preferencia del sistema
    const handleChange = (e: MediaQueryListEvent) => {
      // Solo actualizar clases DOM si estamos en modo "system"
      if (theme === "system") {
        document.documentElement.classList.toggle("dark", e.matches);
      }
    };
    
    // Añadir listener para cambios en la preferencia del sistema
    mediaQuery.addEventListener("change", handleChange);
    
    // Limpiar listener al desmontar
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, [theme]);
  
  return null;
}
